import { EDIT_GERENCIA } from "@/apollo/mutations";
import { GET_GERENCIAS_ALL } from "@/apollo/queries";
import { exMut, exQue } from "@/utils/gql";

export const centroState = {
  gerencias: [],
  gerenciasLoading: false,
};

export const centroMutations = {
  setGerencias(state, gerencias) {
    state.gerencias = gerencias;
  },
  setGerenciasLoading(state, loading) {
    state.gerenciasLoading = loading;
  },
};

export const centroActions = {
  async getGerencias({ commit }, idEmpresa) {
    commit("setGerenciasLoading", true);
    const gerencias = await exQue(GET_GERENCIAS_ALL, { idEmpresa }, true);
    commit("setGerencias", gerencias);
    commit("setGerenciasLoading", false);
},
  async EditGerencia(
    { dispatch, commit },
    {
      idGerencia,
      nombreGerencia,
      bussinessUnit,
      unitNumber,
      idEmpresa,
      idUsuario,
    },
  ) {
    // Devuelve la gerencia editada, o null si falla (exMut ya avisa el error)
    commit("setGerenciasLoading", true);
    try {
      const response = await exMut(
        EDIT_GERENCIA,
        {
          idGerencia,
          nombreGerencia,
          bussinessUnit,
          unitNumber,
          idEmpresa,
          idUsuario,
        },
        "",
        "No se pudo actualizar el centro de costo",
      );
      // Si falla la recarga, el cambio igual quedó guardado (exQue ya deja el
      // error en consola)
      if (response) {
        await dispatch("getGerencias", idEmpresa).catch(() => null);
      }
      return response;
    } finally {
      commit("setGerenciasLoading", false);
    }
  },
};
export const centroGetters = {
  gerenciasWithoutCentroCosto(state) {
    const gerencias = Array.isArray(state.gerencias) ? state.gerencias : [];
    return gerencias.filter((gerencia) => {
      const bussinessUnit = String(gerencia?.bussiness_unit ?? "").trim();
      return !bussinessUnit || bussinessUnit === "0";
    });
  },
  gerenciasWithCentroCosto(state = {}) {
    const gerencias = Array.isArray(state.gerencias) ? state.gerencias : [];
    return gerencias.filter((gerencia) => {
      const bussinessUnit = String(gerencia?.bussiness_unit ?? "").trim();
      return !!bussinessUnit && bussinessUnit !== "0";
    });
  },
};
